import React from 'react';
var FCTheme = /*#__PURE__*/React.createContext({
  theme: 'light'
});
var FCThemeProvider = FCTheme.Provider;
var FCThemeConsumer = FCTheme.Consumer;
export { FCTheme, FCThemeConsumer, FCThemeProvider };